module.exports = __webpack_public_path__ + "static/media/aristoteles_desc6.cad7fb2d.png";